<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29.705"
    height="14.975"
    viewBox="0 0 29.705 14.975"
  >
    <g transform="translate(-1031.904 -580.31)">
      <path
        d="M1053.379,595.285c-1.971,0-4.4-.169-6.212-.324-.433-.036-1.6-.044-2.834-.052-5.765-.035-6-.139-6.171-.626a15,15,0,0,1-.02-4.929,43.714,43.714,0,0,0,1.05-4.977,7.258,7.258,0,0,0,.111-2.266.5.5,0,0,1,.528-.8.436.436,0,0,1,.069.025c.151.058.8.314,1.208.479a21.854,21.854,0,0,0,3.216,0l1.854-.953a.5.5,0,0,1,.7.265l1.875,4.874c2.555,1.141,6.752,2.82,7.728,2.69,1.519-.191,4.265.623,4.669,1.389a8.81,8.81,0,0,1,.464,2.729.5.5,0,0,1-.28.454,20.829,20.829,0,0,1-7.021,2.005C1054.014,595.281,1053.7,595.285,1053.379,595.285Zm-14.294-1.531c.823.129,3.558.145,5.254.156,1.309.008,2.44.015,2.913.055a65.466,65.466,0,0,0,6.988.308,19.771,19.771,0,0,0,6.36-1.767,7.891,7.891,0,0,0-.346-1.949,6.8,6.8,0,0,0-3.651-.87c-1.582.208-7.317-2.343-8.453-2.855a.5.5,0,0,1-.261-.276l-1.749-4.547-1.449.745a.5.5,0,0,1-.189.054,22.6,22.6,0,0,1-3.549,0,.483.483,0,0,1-.15-.036l-.459-.184a14.129,14.129,0,0,1-.162,1.932,43.839,43.839,0,0,1-1.065,5.046A14.091,14.091,0,0,0,1039.085,593.754Z"
      />
      <path
        d="M1051.893,592.708q-2.043,0-4.051-.125c-2-.111-9.341-.41-9.415-.413l.041-1c.074,0,7.42.3,9.432.415a66.638,66.638,0,0,0,8.142,0c.536-.153,3.069-1.128,4.321-1.62l.366.93c-.15.059-3.68,1.447-4.527,1.672Q1054.025,592.709,1051.893,592.708Z"
      />
      <rect
        width="2.117"
        height="1.001"
        transform="translate(1046.472 586.922) rotate(-24.564)"
      />
      <rect
        width="2.07"
        height="1.001"
        transform="matrix(0.837, -0.547, 0.547, 0.837, 1048.351, 588.088)"
      />
      <rect
        width="2.229"
        height="1"
        transform="matrix(0.715, -0.699, 0.699, 0.715, 1050.104, 589.143)"
      />
      <rect
        width="2.159"
        height="1.001"
        transform="matrix(0.584, -0.812, 0.812, 0.584, 1052.172, 589.971)"
      />
      <rect
        width="1.631"
        height="1.001"
        transform="matrix(0.316, -0.949, 0.949, 0.316, 1054.231, 590.453)"
      />
      <g>
        <circle
          cx="2"
          cy="2"
          r="2"
          transform="translate(1040.647 585.309)"
          fill="none"
        />
        <path
          d="M1042.647,589.31a2,2,0,1,1,2-2A2,2,0,0,1,1042.647,589.31Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,1042.647,586.31Z"
        />
      </g>
      <g>
        <rect
          width="1"
          height="5.741"
          transform="translate(1033.913 581.801)"
        />
        <path
          d="M1031.9,582.636l2.79-2.326,2.1,2.379-.75.662-1.456-1.65-2.043,1.7Z"
        />
        <path
          d="M1031.9,586.131l.641-.768,2.043,1.7,1.456-1.647.75.662-2.1,2.379Z"
        />
      </g>
    </g>
  </svg>
</template>
